import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import CardSeguimiento from "./CardSeguimiento.jsx";
import DetailContact from './DetailContact.jsx';
import AgregarContacto from "./AgregarContacto.jsx"
import { getAllSeguimientos, getContactByID } from "../../endpoints"
import test from "../assets/Animacion-nosotros.webm"
import { useParams } from "react-router-dom";
import CustomCircularProgress from "../../Components/Loading/CustomCircularProgress.jsx"

const Seguimientos = ({ user }) => {
  const [contacts, setContacts] = useState([]);
  const [contactsFilter, setContactsFilter] = useState([]);
  const [seActualizoContacto, setSeActualizoContacto] = useState(false);
  const params = useParams();
  const [verMas, setVerMas] = useState(false);
  const [openModalObservaciones, setOpenModalObservaciones] = useState(false);
  const [filterStatusList, SetFilterStatusList] = useState("Todos");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [buscador, setBuscador] = useState();
  const [ultimaPaginaSolicitada, setUltimaPaginaSolicitada] = useState(1);
  const scrollContainerRef = useRef(null);
  const [openAddContact, setOpenAddContact] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openModalAddSeguimiento, setOpenModalAddSeguimiento] = useState(false);
  const [idContact, setIdContact] = useState();
  const [selectedContact, setSelectContact] = useState();
  const [totalcontactViewer, setTotalcontactViewer] = useState();
  const [formData, setFormData] = useState({
    nombre: '',
    apellido: '',
    telefono: '',
    email: '',
    ramo: '',
    asesorAsignado: '',
  });


  const getContactID = async () => {
    getContactByID(idContact).then((response) => {
      if (response.status === 200) {
        setSelectContact(response.data)
        setTimeout(() => {
          setLoading(false);
        }, 500);
      } else {
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    if (idContact) {
      setLoading(true)
      getContactID()
    }
  }, [idContact]);


  const handleNextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  const visibleVerMas = (currentPage, totalPages) => {
    if (currentPage < totalPages) {
      setVerMas(true);
    } else {
      setVerMas(false)
    }
  };

  const getContacts = async (buscador) => {
    setLoading2(true);
    getAllSeguimientos({
      page: currentPage,
      perPage: buscador ? null : 30,
      filterBy: buscador,
      userId: user.id,
      userType: user.type,
      seguimientoStatus: filterStatusList
    }).then((response) => {
      if (response?.status === 200) {
        if (buscador) {
          setContactsFilter(response.data.seguimientos)
          setUltimaPaginaSolicitada(response.data.page)
          setTotalcontactViewer(response.data.total)
          setTotalPages(Math.ceil(response.data.total)); // Suponiendo que tienes la información del total de contactos
          setLoading2(false)
        }
        else if (filterStatusList !== "Todos") {
          setUltimaPaginaSolicitada(response.data.page)
          setContacts(response.data.seguimientos)
          setTotalcontactViewer(response.data.total)
          setTotalPages(Math.ceil(response.data.total / 30)); // Suponiendo que tienes la información del total de contactos
          setLoading2(false)
        }
        else {
          const newContacts = [...contacts, ...response.data.seguimientos];
          setUltimaPaginaSolicitada(response.data.page)
          setContacts(newContacts);
          setTotalcontactViewer(response.data.total)
          setTotalPages(Math.ceil(response.data.total / 30)); // Suponiendo que tienes la información del total de contactos
          setLoading2(false)
        }
      } else {
        setLoading2(false)
      }
    });
  };


  useEffect(() => {
    setLoading2(true)
    getContacts(buscador)
  }, [currentPage, buscador, filterStatusList]);

  useEffect(() => {
    setCurrentPage(1)
  }, [filterStatusList]);

  useEffect(() => {
    visibleVerMas(currentPage, totalPages)
  }, [currentPage, totalPages]);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    const handleScroll = () => {
      if (scrollContainer.scrollHeight - parseInt(scrollContainer.scrollTop) === scrollContainer.clientHeight) {
        visibleVerMas(currentPage, totalPages);
      }
    };
    scrollContainer.addEventListener('scroll', handleScroll);
    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, [totalPages, currentPage, buscador, scrollContainerRef.current]);


  const handlerOpenModal = () => {
    setOpenModal(true);
  }

  const handlerOpenModalSeguimiento = () => {
    setOpenModalAddSeguimiento(true);
  }

  const handlerOpenModalObservaciones = () => {
    setOpenModalObservaciones(true);
  }

  const closeModalObservaciones = () => {
    setOpenModalObservaciones(false);
  }

  const closeModal = () => {
    setOpenModal(false);
  }

  const closeModalAddSeguimiento = () => {
    setOpenModalAddSeguimiento(false);
  }

  const handleChangeBuscador = (e) => {
    const { value } = e.target;
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0;
    }
    setBuscador(value);
  };

  return (

    <ContainerBox >
      <DivContentFilters params={params}>
        <DivRow>
          <DivColumn1>
            <Text1>{`Total: ${totalcontactViewer ? totalcontactViewer : 0}`}</Text1>
          </DivColumn1>
        </DivRow>
        <DivRow1>
          <ItemAux style={{
            opacity: filterStatusList === "Todos" ? 1 : 0.5,
            justifyContent: "center",
            cursor: "pointer",
          }}
            onClick={() => SetFilterStatusList("Todos")}
          >
            <CircleItem
              style={{
                backgroundColor: "#003049",
              }}
            />
            <TextItem>
              Todos
            </TextItem>
          </ItemAux>
          <ItemAux style={{
            opacity: filterStatusList === "No le interesa" ? 1 : 0.5,
            justifyContent: "center",
            cursor: "pointer",
          }}
            onClick={() => SetFilterStatusList("No le interesa")}
          >
            <CircleItem
              style={{
                backgroundColor: "#911813",
              }}
            />
            <TextItem>
              No le interesa
            </TextItem>
          </ItemAux>
          <ItemAux style={{
            opacity: filterStatusList === "Esperando Respuesta" ? 1 : 0.5,
            justifyContent: "center",
            cursor: "pointer",
          }}
            onClick={() => SetFilterStatusList("Esperando Respuesta")}
          >
            <CircleItem
              style={{
                backgroundColor: "#e8be01",
              }}
            />
            <TextItem>
              Esp. Resp
            </TextItem>
          </ItemAux>
          <ItemAux style={{
            borderRadius: "8px",
            opacity: filterStatusList === "Esperando Datos" ? 1 : 0.5,
            justifyContent: "center",
            cursor: "pointer",
          }}
            onClick={() => SetFilterStatusList("Esperando Datos")}
          >
            <CircleItem
              style={{
                backgroundColor: "#3bc15e",
              }}
            />
            <TextItem>
              Esp. Datos
            </TextItem>
          </ItemAux>
        </DivRow1>
        <Input
          type="text"
          placeholder="Buscar..."
          value={buscador}
          onChange={handleChangeBuscador}
        />
        <ScrollContainer ref={scrollContainerRef} >
          {contacts && contacts.length > 0 && !buscador ?
            (
              <>
                {contacts.map((contact, index) => (
                  <CardSeguimiento
                    key={index}
                    contact={contact}
                    handlerOpenModalObservaciones={handlerOpenModalObservaciones}
                    handlerOpenModal={handlerOpenModal}
                    formData={formData}
                    setFormData={setFormData}
                    setSelectContact={setSelectContact}
                    selectedContact={selectedContact}
                    setIdContact={setIdContact}

                  />
                ))}
              </>
            ) : (
              <>
                {!buscador ?
                  <Text style={{ textAlign: 'center' }}>No se encontraron resultados.</Text> : null
                }
              </>
            )
          }

          {buscador && contactsFilter && contactsFilter.length > 0 ?
            (
              <>
                {contactsFilter.map((contact, index) => (
                  <CardSeguimiento
                    key={index}
                    contact={contact}
                    handlerOpenModalObservaciones={handlerOpenModalObservaciones}
                    handlerOpenModal={handlerOpenModal}
                    formData={formData}
                    setFormData={setFormData}
                    setSelectContact={setSelectContact}
                    selectedContact={selectedContact}
                    setIdContact={setIdContact}
                  />
                ))}
              </>
            ) : (
              <>
                {buscador ?
                  <Text style={{ textAlign: 'center' }}>No se encontraron resultados.</Text> : null
                }
              </>
            )
          }
        </ScrollContainer>
        {
          verMas ?
            <BtnVerMas onClick={handleNextPage}>
              Ver mas
            </BtnVerMas>
            : null
        }
      </DivContentFilters>
      <DivFlexColumn params={params} >
        {
          openAddContact ?
            <AgregarContacto
              openAddContact={openAddContact}
              setOpenAddContact={setOpenAddContact}
            />
            : null
        }
        {
          loading === false && selectedContact?.id !== undefined ? (
            <DetailContact
              selectedContact={selectedContact}
              formData={formData}
              handlerOpenModal={handlerOpenModal}
              handlerOpenModalObservaciones={handlerOpenModalObservaciones}
              openModalObservaciones={openModalObservaciones}
              openModal={openModal}
              handlerOpenModalSeguimiento={handlerOpenModalSeguimiento}
              closeModalObservaciones={closeModalObservaciones}
              closeModal={closeModal}
              setSeActualizoContacto={setSeActualizoContacto}
              getContacts={getContacts}
              getContactID={getContactID}
              scrollContainerRef={scrollContainerRef}
              setContacts={setContacts}
              closeModalAddSeguimiento={closeModalAddSeguimiento}
              openModalAddSeguimiento={openModalAddSeguimiento}
              user={user}
            />
          ) : loading === false && !selectedContact?.id ? (
            <DivBoxContainer>
              <VideoCont muted autoPlay loop src={test} />
            </DivBoxContainer>
          ) : (
            <CustomCircularProgress size={50} padding='15vw' />
          )
        }
      </DivFlexColumn>
    </ContainerBox>

  );
};

const BtnVerMas = styled.div`
  width: -webkit-fill-available;
  padding:0px 8px;
  border:solid 2px #092a3f;
  border-radius:8px; 
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  height: 34px;
  color: #003049;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 13px;
  cursor: pointer;
  transition: border-color 0.3s ease;
  box-sizing: border-box;
`;

const CircleItem = styled.div`
  height:12px;
  width:12px;
  border-radius:50%
`

const TextItem = styled.span`
  color: #334443;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 10px;
  width:auto;
`

const ItemAux = styled.div`
  width:auto;
  color: #003049;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap:4px;
`

const VideoCont = styled.video`
  border-radius: 8px;
  height: auto;
  width: 50%;
  margin: 15%;
`;

const DivBoxContainer = styled.div`
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  width: -webkit-fill-available;
  height: auto;
  justify-content: center;
`;

const DivContentFilters = styled.div`
  width: auto;
  min-width: 326px;
  max-width: 326px;
  height: auto;
  min-height: 98vh !important;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0px;
  padding: 0px 0px 8px 24px;
  background-color: #FFFFFF;
  box-sizing: border-box;
  @media only screen and (min-width:0px) and (max-width:1100px){
    display:${(prop) => prop.params.id ? 'none' : 'flex'};
    width: -webkit-fill-available;
  }
`;

const DivFlexColumn = styled.div`
  background-color: rgba(255, 255, 255, 0.8);
  width: -webkit-fill-available;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  max-height: 85vh;
  min-height: 85vh;
  overflow-y: auto;
  border-radius: 8px;
  margin-right: 16px;
  margin-top: 8px;
  justify-content: flex-start;

  &::-webkit-scrollbar {
    height: 4px;
    width: 3px;
    background-color: transparent !important;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #003049 !important;
    border-radius: 8px;
  }

  @media only screen and (min-width:0px) and (max-width:1100px){
    display:${(prop) => prop.params.id ? 'flex' : 'none'};
    margin-right: 0px;
  }
`;

const Input = styled.input`
  box-shadow: rgb(0 0 0 / 6%) 0px 2px 4px 0px inset;
  width: -webkit-fill-available;
  min-width: -webkit-fill-available;
  margin: 8px 0px;
  padding:5px;
  border:none;
  outline: none;
  background:#FFFFFF;
  border-radius:8px;
  height:26px;
  min-height:26px;
  max-width: 10vw;
  font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: #07082c;
  &:placeholder{
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: #07082c;
  }
`;

const ContainerBox = styled.div`
  width: -webkit-fill-available;
  height: auto;
  min-height: 95vh;
  max-height: 95vh;
  overflow-y: hidden;
  max-width: calc(100vw - 84px);
  gap: 16px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 1% 16px 0px 1%;
  background-color:#FFFFFF;
  border-radius:8px;
  box-shadow: 0px 1.5px 2px 0px rgba(16, 24, 40, 0.10);
  border: 1px solid var(--Neutral-Gray-Gray-100, #E0E2E7);

  @media only screen and (min-width:0px) and (max-width:1100px){
    margin: 5vh 0px 0px 0px;
    max-width: calc(100vw - 0px);
  }
`;

const DivRow = styled.div`
  width: -webkit-fill-available;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: 0.5em 0em 0.5em 0em;
  justify-content: space-between;
`;

const DivColumn1 = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
`;

const DivRow1 = styled.div`
  width: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  justify-content: flex-start;
`;

const ScrollContainer = styled.div`
  width: -webkit-fill-available;
  height: auto;
  max-height: calc(100vh - 35vh) !important;
  overflow-y: auto;
  overflow-x: hidden;
  gap: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0%;
  scroll-behavior: smooth;
  padding: 8px 0px 0px 0px;
  border-top: 2px solid #003049;
  justify-content: flex-start;

  &::-webkit-scrollbar {
    height: 4px;
    width: 3px;
    background-color: transparent !important;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #003049 !important;
    border-radius: 8px;
  }

`;


const Text = styled.span`
  width: -webkit-fill-available;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #003049;
`;

const Text1 = styled.span`
  width: -webkit-fill-available;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 18px;
  color: #003049;
`;

export default Seguimientos;